module.exports = __webpack_public_path__ + "static/media/ic_planning_remove.ec24d377.svg";